import { prepareSelectionAttributes } from 'src/actuators/checkout/prepareSelectionAttributes.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { LocationState } from 'src/actuators/LocationState.ts';
import { Accessory } from 'src/common/prepareAccessories.ts';
import { ActuatorAccessoriesPageData } from 'src/actuators/accessories/ActuatorAccessoriesPageMapping.ts';
import { shapeSelectionExportTable } from 'src/projects/utils/shapeSelectionExportTable.ts';

export const prepareSelectionExportData = ({
    accessories,
    locationState,
    actuator,
    userSettings,
}: {
    accessories: Accessory<ActuatorAccessoriesPageData['accessories']['accessories']['0']>[];
    actuator: ActuatorAccessoriesPageData['accessories']['actuator'];
    locationState: LocationState;
    userSettings: UserSettings;
}) => {
    const attr = prepareSelectionAttributes(actuator);

    return shapeSelectionExportTable({
        attr,
        accessories,
        locationState,
        userSettings,
        product: actuator,
    });
};
